export default {
  driver_performance_events_title: "Driver Performance - Events",
  driver_performance_events_event: "Event",
  driver_performance_events_date: "Date",
  driver_performance_events_driver: "Driver",
  driver_performance_events_asset: "Asset",
  driver_performance_events_refCase: "Ref Case",
  driver_performance_events_actions: "Actions",
  driver_performance_events_status: "Status",
  driver_performance_events_tag: "Tag",
  driver_performance_events_custom: "Custom",
  driver_performance_events_today: "Today",
  driver_performance_events_yesterday: "Yesterday",
  driver_performance_events_week: "This Week",
  driver_performance_events_lastWeek: "Last Week",
  driver_performance_events_thisMonth: "This Month",
  driver_performance_events_lastMonth: "Last Month",
  driver_performance_events_quarter: "This Quarter",
  driver_performance_events_lastQuarter: "Last Quarter",
  driver_performance_tagId: "TagID",
  driver_performance_tagName: "Tag Name",
  driver_performance_searchInput: "Search by Event, Driver and Asset",
  driver_performance_noMoreItems: "There are no more items",


  driver_performance_events_last7days: "Last 7 Days",
  driver_performance_events_last15days: "Last 15 Days",
  driver_performance_events_last30Days: "Last 30 Days",



  driver_performance_coachnow: "Coach Now",
  driver_performance_createincident: "Create Incident",
  driver_performance_falsepositive: "False Positive",
  driver_performance_highlightcoaching: "Queue for Coaching",
  driver_performance_verified: "Verified",
  driver_performance_noissue: "No Issue",
  driver_performance_disputed: "Disputed",
  driver_performance_noDriver: "No Driver",
  driver_performance_assignDriver: "Assign Driver",

  driver_performance_events_sendToCoaching: "Send to Coaching",
  driver_performance_events_coach_now: "Coach Now",
  driver_performance_events_assignDriver: "Assign Driver",
  driver_performance_events_setStatus: "Set Status",
  driver_performance_noDriversSelected: "No drivers selected for coaching",

  driver_performance_bulkoptions: "Bulk Options",
  driver_performance_bulkoptions_sendToCoaching: "Send to Coaching",
  driver_performance_bulkoptions_setStatus: "Set Status",
  driver_performance_bulkoptions_selected_limit: "You cannot select more than 100 events for bulk options.",

  driver_performance_events_withoutDriver: "Cannot send to coaching: Some events do not have a driver assigned. Please assign drivers first.",
  driver_performance_noValidEvents: "No valid events to send to coaching",
  driver_performance_driversWithoutEvents: "Some drivers do not have events assigned",

  driver_performance_events_withCase: "Cannot send to coaching: {count} event(s) already have a case assigned. Please deselect events with existing cases.",
  driver_performance_drivers_petition_coach_now: "Start process to bulk coaching generates cases automatically has started successfully.",
  driver_performance_events_not_active_in_asset_profile: "The following risk events are not active: {events}.",
  driver_performance_events_warning: "Warning",
};
